import { formatDistance, differenceInDays, format } from "date-fns";
import { useMemo } from "react";

export const FormattedLastOpenDate = ({ date }: { date?: Date }) => {
  return useMemo(() => {
    if (!date) return "Never opened";

    const dateObj = new Date(date);
    const now = new Date();
    const daysDiff = differenceInDays(now, dateObj);

    if (daysDiff >= 1) {
      return format(dateObj, "dd/MM/yyyy, hh:mma");
    }

    return formatDistance(dateObj, now) + " ago";
  }, [date]);
};
